"use strict";
/**
 * A Class used for uploading/adding files to IPFS inside the Browser
 */

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var IpfsXml = /*#__PURE__*/function () {
  /**
   * Create a new XML HTTP Request IPFS Uploader
   * @param  {File|Blob} file - The [File](https://developer.mozilla.org/en-US/docs/Web/API/File) or [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) you want added to IPFS.
   * @param {Object} options - The Options for this Upload
   * @param {String} options.host - The hostname of the IPFS API server to upload to (i.e. "ipfs-dev.alexandria.io")
   * @param {String} options.protocol - The Protocol of the IPFS API server to upload to (i.e. "https")
   * @param {Number} options.port - The Port of the IPFS API server to upload to (i.e. `443`)
   * @param {Object} options.oip_auth - An object that contains a signed message, the address that signed the message, and the signature for them both
   *
   * @example
   * let uploader = new XMLRequestIPFSAdd(input.files[0], {
   *  "host": "ipfs-dev.alexandria.io",
   *  "protocol": "https",
   *  "port": 443,
   *  "oip_auth": {
   *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
   *    message:'1534278675842{"oip042":{}}',
   *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
   *  }
   * })
   */
  function IpfsXml(file, options) {
    _classCallCheck(this, IpfsXml);

    this.file = file;
    this.options = options;
    this.uploadXmlhttprequest = new XMLHttpRequest(); // eslint-disable-line

    this.progressSubscribers = [];
  }
  /**
   * Subscribe to upload Progress events
   * @param  {Function} progressFunction - The function you want called when there is a progress update available
   *
   * @example
   * let uploader = new XMLRequestIPFSAdd(input.files[0], {
   *  "host": "ipfs-dev.alexandria.io",
   *  "protocol": "https",
   *  "port": 443,
   *  "oip_auth": {
   *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
   *    message:'1534278675842{"oip042":{}}',
   *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
   *  }
   * })
   *
   * uploader.onProgress((progress_message) => {
   *  console.log("Progress! " + JSON.stringify(progress_message))
   * })
   */


  _createClass(IpfsXml, [{
    key: "onProgress",
    value: function onProgress(progressFunction) {
      this.progressSubscribers.push(progressFunction);
    }
    /**
     * Start the File Upload to the server
     * @return {Promise<Object>} Returns a Promise that will resolve to the IPFS Added object JSON
     *
     * @example
     * let uploader = new XMLRequestIPFSAdd(input.files[0], {
     *  "host": "ipfs-dev.alexandria.io",
     *  "protocol": "https",
     *  "port": 443,
     *  "oip_auth": {
     *    address:"oNRs1nuR1vUAjWJwhMtxJPQoTFAm9MWz1G",
     *    message:'1534278675842{"oip042":{}}',
     *    signature:"Hw2iuomv/fhYYoKX8bNroVXmOvbh/e9gqZjP+I9kZymHD72mqtDw1qjN6/Qh4nhTDOHI8mkxbWtsaLSTuCkSihU="
     *  }
     * })
     *
     * uploader.onProgress((progress_message) => {
     *  console.log("Progress! " + JSON.stringify(progress_message))
     * })
     *
     * uploader.start().then((success_response) => {
     *  console.log("Upload Complete! " + JSON.stringify(success_response))
     * })
     */

  }, {
    key: "start",
    value: function start() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // The "load" event is fired when the request has finished
        _this.uploadXmlhttprequest.addEventListener('load', function () {
          var response = JSON.parse(_this.uploadXmlhttprequest.responseText); // Normalize to match regular ipfs-api add output

          resolve({
            path: response.Name,
            hash: response.Hash,
            size: response.Size
          });
        });

        _this.uploadXmlhttprequest.upload.onprogress = function (progress) {
          if (progress.lengthComputable) {
            var percent = parseFloat((progress.loaded / progress.total * 100).toFixed(2));

            var _iterator = _createForOfIteratorHelper(_this.progressSubscribers),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var progressFunction = _step.value;
                progressFunction({
                  upload_progress: percent,
                  bytes_uploaded: progress.loaded,
                  bytes_total: progress.total
                });
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }; // Create the upload URL


        var builtURL = '';
        builtURL += _this.options.protocol + '://';
        builtURL += _this.options.host;
        var addPort = true; // Don't add the port if the protocol matches the port

        if (_this.options.protocol === 'http' && _this.options.port === 80) {
          addPort = false;
        }

        if (_this.options.protocol === 'https' && _this.options.port === 443) {
          addPort = false;
        }

        if (addPort) {
          builtURL += ':' + _this.options.port;
        } // Set the upload to use the URL


        _this.uploadXmlhttprequest.open('POST', builtURL + '/api/v0/add?json=true'); // We are expecting a JSON response


        _this.uploadXmlhttprequest.setRequestHeader('accept', 'application/json');

        _this.uploadXmlhttprequest.setRequestHeader('OIP-Auth', JSON.stringify(_this.options.oip_auth)); // Set the encoding type since we are going to be sending FormData


        _this.uploadXmlhttprequest.enctype = 'multipart/form-data'; // Create a Form to send to the server

        var form = new FormData(); // eslint-disable-line

        form.append('path', _this.file, _this.file.name); // Start the upload

        _this.uploadXmlhttprequest.send(form);
      });
    }
  }]);

  return IpfsXml;
}();

module.exports = IpfsXml;